export default "__VITE_ASSET__DtVJNy9Q__"